module.exports = __webpack_public_path__ + "img/logo.77817a7b.svg";